export const SITE_NAME = "BuzzwareTech | Simple, project management tool.";
export const SITE_TITLE = "BuzzwareTech | Simple, project management tool.";
export const SITE_DESCRIPTION =
  "Open-source project management tool to manage work items, cycles, and product roadmaps easily";
export const SITE_KEYWORDS =
  "software development, plan, ship, software, accelerate, code management, release management, project management, work items tracking, agile, scrum, kanban, collaboration";
export const SITE_URL = "https://app.buzzwareTech.so/";
export const TWITTER_USER_NAME =
  "BuzzwareTech | Simple, project management tool.";

// BuzzwareTech Sites Metadata
export const SPACE_SITE_NAME =
  "BuzzwareTech Publish | Make your BuzzwareTech boards and roadmaps pubic with just one-click. ";
export const SPACE_SITE_TITLE =
  "BuzzwareTech Publish | Make your BuzzwareTech boards public with one-click";
export const SPACE_SITE_DESCRIPTION =
  "BuzzwareTech Publish is a customer feedback management tool built on top of buzzwareTech.so";
export const SPACE_SITE_KEYWORDS =
  "software development, customer feedback, software, accelerate, code management, release management, project management, work items tracking, agile, scrum, kanban, collaboration";
export const SPACE_SITE_URL = "https://app.buzzwareTech.so/";
export const SPACE_TWITTER_USER_NAME = "planepowers";
